export default {
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
};
